import { render, staticRenderFns } from "./ccPurchaseOrderDetail.vue?vue&type=template&id=d64a2cd0&"
import script from "./ccPurchaseOrderDetail.vue?vue&type=script&lang=js&"
export * from "./ccPurchaseOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ccPurchaseOrderDetail.vue?vue&type=style&index=0&id=d64a2cd0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports